var render = function render(){var _vm=this,_c=_vm._self._c;return _c('admin-layout',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v("\n        Admin Dashboard\n    ")]},proxy:true}])},[_vm._v(" "),_c('div',{staticClass:"py-4"},[_c('div',{staticClass:"max-w-7xl mx-auto"},[_c('div',{staticClass:"bg-white overflow-hidden sm:rounded-lg"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }